import GoldGamesFreeSpinsForm from '../organisms/forms/GoldGamesFreeSpinsForm';
import { DialogType } from '../../@types';
import type { ModalOptions } from '../../contexts/ModalContext';

import CompetitionForm from '../organisms/forms/CompetitionForm';
import CreateEventForm from '../organisms/forms/CreateEventForm';
import EditEventForm from '../organisms/forms/EditEventForm';
import MarketGroupForm from '../organisms/forms/MarketGroupForm';
import MarketTypeForm from '../organisms/forms/MarketTypeForm';
import OutcomeTypeForm from '../organisms/forms/OutcomeTypesForm';
import ParticipantForm from '../organisms/forms/ParticipantForm';
import PlayerForm from '../organisms/forms/PlayerForm';
import ResultsForm from '../organisms/forms/ResultsForm';
import RiskManagementPlayerSettingsDialog from '../organisms/forms/RiskManagementPlayerSettingsDialog';
import SportsForm from '../organisms/forms/SportsForm';
import TournamentForm from '../organisms/forms/TournamentForm';
import ConditionGroupForm from '../organisms/forms/conditions/ConditionGroupForm';
import EditConditionTypeForm from '../organisms/forms/conditions/EditConditionTypeForm';
import CRMTaskForm from '../organisms/forms/crm/CRMTaskForm';
import CustomerForm from '../organisms/forms/crm/CustomerForm';
import AddAdminCreditsForm from '../organisms/forms/crm/wallet/AddAdminCreditsForm';
import FilterDailyReports from '../organisms/FilterDailyReports';
import HandleCreditsForm from '../organisms/forms/crm/wallet/HandleCreditsForm';
import JackpotForm from '../organisms/forms/JackpotForm';
import CreateOutrightForm from '../organisms/forms/CreateOutrightForm';
import EditOutrightForm from '../organisms/forms/EditOutrightForm';
import MarketplaceForm from '../organisms/forms/MarketplaceForm';
import PartnerForm from '../organisms/forms/crm/PartnerForm';
import MarketMixForm from '../organisms/forms/MarketMixForm';
import CashbackBonusForm from '../organisms/forms/CashbackBonusForm';
import NumOfSelectionsBonusForm from '../organisms/forms/NumOfSelectionsBonusForm';
import CampaignForm from '../organisms/forms/CampaignForm';
import AffiliateGlobalBonusForm from '../organisms/forms/AffiliateGlobalBonusForm';
import CasinoCategoryForm from '../organisms/forms/CasinoCategoryForm';
import CasinoGameForm from '../organisms/forms/CasinoGameForm';
import WelcomeBonusForm from '../organisms/forms/welcome-bonus/WelcomeBonusForm';
import CreateSuperAdminAccountForm from '../organisms/forms/CreateSuperAdminAccountForm';
import GgaFreeSpinsForm from '../organisms/forms/GgaFreeSpinsForm';

// Form-level modal options live with the registration so create and edit callers cannot drift.
const forms = {
  sports: { Form: SportsForm },
  competitions: { Form: CompetitionForm },
  tournaments: { Form: TournamentForm },
  participants: { Form: ParticipantForm },
  players: { Form: PlayerForm },
  markets: { Form: MarketTypeForm },
  outcomes: { Form: OutcomeTypeForm },
  customers: { Form: CustomerForm },
  tasks: { Form: CRMTaskForm },
  editEvent: { Form: EditEventForm },
  createEvent: { Form: CreateEventForm },
  createOutright: { Form: CreateOutrightForm },
  editOutright: { Form: EditOutrightForm },
  results: { Form: ResultsForm },
  'conditions-type': { Form: EditConditionTypeForm },
  'conditions-groups': { Form: ConditionGroupForm },
  'market-groups': { Form: MarketGroupForm },
  'market-mix': { Form: MarketMixForm },
  'handle-credits': { Form: HandleCreditsForm },
  'add-admin-credits': { Form: AddAdminCreditsForm },
  daily: { Form: FilterDailyReports },
  'player-risk-management': { Form: RiskManagementPlayerSettingsDialog },
  jackpot: { Form: JackpotForm },
  cashback: { Form: CashbackBonusForm },
  welcome: { Form: WelcomeBonusForm, modalOptions: { dialogSize: 'wide' } },
  marketplace: { Form: MarketplaceForm },
  categories: { Form: CasinoCategoryForm },
  games: { Form: CasinoGameForm },
  partners: { Form: PartnerForm },
  selections: { Form: NumOfSelectionsBonusForm },
  campaigns: { Form: CampaignForm, modalOptions: { dialogSize: 'wide' } },
  'affiliate-global-bonus': { Form: AffiliateGlobalBonusForm },
  'super-admin-account': { Form: CreateSuperAdminAccountForm },
  'gold-games-free-spins': { Form: GoldGamesFreeSpinsForm, modalOptions: { dialogSize: 'wide' } },
  'gga-free-spins': { Form: GgaFreeSpinsForm },
} as const;

export type FormTypes = keyof typeof forms;

export const getFormModalOptions = (form: FormTypes): ModalOptions | undefined => {
  const definition = forms[form];

  return definition && 'modalOptions' in definition ? definition.modalOptions : undefined;
};

type Props = DialogType & {
  form: FormTypes;
  item?: unknown;
  [key: string]: unknown;
};

const FormModal = ({ form, item, closeModal = () => void 0, ...rest }: Props) => {
  const FormComponent = forms[form].Form;

  // @ts-expect-error
  return <FormComponent item={item} closeModal={closeModal} {...rest} />;
};

export default FormModal;
